import React from 'react';
import stylesPlain from './plain.module.css';

import Field from './Field';
import Label from './Label';

import { getDefinedValue, getDefinedItem, getCurrentResource } from '../../util/tools';
import { 
	IET_SET_VALUE, IET_ADD_LIST_ITEM, IET_MOVE_UP_LIST_ITEM, 
	IET_MOVE_DOWN_LIST_ITEM, IET_DELETE_LIST_ITEM 
} from '../../util/realm/instance';

import iconAdd from '../../assets/icons/png24x24/Add.png';
import iconMoveUp from '../../assets/icons/png24x24/Up.png';
import iconMoveDown from '../../assets/icons/png24x24/Down.png';
import iconDelete from '../../assets/icons/png24x24/Delete.png';

class FieldList extends Field {

	resourceFieldList = null;
	
	/*
		useProposal
		confirmDelete
		disableAddItems
		disableMoveItems
		disableDeleteItems
		labelEmptyToHeader
		onRowClick
		title
		tooltip
		header
		styles
			label
		table
			width
			styles
				table
	*/
	constructor(props) {
		super(props);
		this.resourceFieldList = getCurrentResource().components.plain.FieldList;
		this.refConfirmDeleteModalDialog = React.createRef();
		this.createButtonDeleteItemHtml = this.createButtonDeleteItemHtml.bind(this); 
		if( this.field ) {
			this.state.value = getDefinedValue( this.field.value, []);
			this.state.selectedIndex = (this.field.value.length > 0) ? 0 :-1;
		}
	}
	completeComponentDidUpdate(prevProps, prevState, doInit) {
		if ( doInit ) {
			let index = this.state.selectedIndex;
			if( index >= this.field.value.length ) {
				index = this.field.value.length - 1;
				this.setState({ selectedIndex: index });
			}
			if( index < 0 && this.field.value.length > 0 ) {
				index = 0;
				this.setState({ selectedIndex: index });
			}
			this.setState({ value: getDefinedValue( this.field.value, []) });
		}
	}
	init() {
		super.init();
		if( this.field ) {
			if( this.props.useProposal ) {
				let length = this.field.value.length;
				let addProposal = false;
				if( length == 0 ) {
					addProposal = true;
				} else {
					if( ! this.field.value[length-1].isProposal ) {
						if( this.isValueEmpty(length-1) )
							this.field.value[length-1].isProposal = true;
						else
							addProposal = true;
					}
				}
				if( addProposal ) {
					this.props.instance.addListItem(this.field);
					length++;
					this.field.value[length-1].isProposal = true;
				}
			}
		}
	}
	isValueEmpty(valueIndex) {
		return false;
	}

	async handleInstanceChange(event) {
		if( event.eventType == IET_SET_VALUE && event.field.parent == this.field) {
			let instance = this.props.instance;
			if( this.props.useProposal && event.field.isProposal ) {
				event.field.isProposal = false;
				let newItem = instance.addListItem(this.field);
				newItem.isProposal = true;
			}
			this.setState({value: this.field.value});
		} else if( event.eventType == IET_ADD_LIST_ITEM && event.field == this.field) {
			this.setState({	value: this.field.value , selectedIndex: event.index});
		} else if( event.eventType == IET_MOVE_UP_LIST_ITEM && event.field == this.field) {
			this.setState({	value: this.field.value });
		} else if( event.eventType == IET_MOVE_DOWN_LIST_ITEM && event.field == this.field) {
			this.setState({	value: this.field.value });
		} else if( event.eventType == IET_DELETE_LIST_ITEM && event.field == this.field) {
			this.setState({	value: this.field.value });
		}
	}
	handleRowClick = (index) => {
		this.setState({selectedIndex: index}, this.notifyRowClickListener)
	}
	notifyRowClickListener = () => {
		if( this.props.onRowClick ) {
			this.props.onRowClick(this.state.selectedIndex);
		} 
	}

	addItem = () => {
		this.props.instance.addListItem(this.field, null, true);
	}
	moveUpItem = () => {
		let index = this.state.selectedIndex;
		if( index <= 0 )
			return;
		if( this.props.useProposal && this.field.value[index].isProposal )
			return;
		this.props.instance.moveUpItem(this.field, index);
		this.setState({ selectedIndex: index-1 });
	}
	moveDownItem = () => {
		let index = this.state.selectedIndex;
		if( index >= this.field.value.length-1 )
			return;
		if( this.props.useProposal && index >= this.field.value.length-2 )
			return;
		this.props.instance.moveDownItem(this.field, index);
		this.setState({ selectedIndex: index+1 });
	}
	deleteItem = () => {
		let index = this.state.selectedIndex;
		if( index < 0 || index >= this.field.value.length )
			return;
		if( this.props.useProposal && this.field.value[index].isProposal )
			return;

		let confirm = getDefinedValue(this.props.confirmDelete, true);
		if( confirm ) {
			let app = this.props.plain.props.app;
			app.refConfirmDeleteModalDialog.current.openModal(
				this.resourceFieldList.msgConfirmDelete, () => {this.doDelete(index)});
		} else {
			this.doDelete(index);
		}
	}
	doDelete = (index) => {
		this.props.instance.deleteListItem(this.field, index);
		if( index >= this.field.value.length ) {
			this.setState({ selectedIndex: index-1 });
		}
	}	

	createButtonAddHtml() {
		if( this.props.disableAddItems )
			return null;
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonAddHtml = null;
		if( ! this.props.useProposal ) 
			buttonAddHtml = (
				<button type='button' className={stylesPlain.buttonIcon} style={{marginRight: '5px'}}
					onClick={this.addItem} disabled={readOnly} title={this.resourceFieldList.buttonAddTooltip}
				>
					<img src={iconAdd} />
				</button>
			);
		return buttonAddHtml;
	}
	createMoveItemsButtonsHtml() {
		let moveItemsButtonsHtml = null;
		let readOnly = getDefinedValue( this.props.readOnly, false);
		if( ! this.props.disableMoveItems ) {
			moveItemsButtonsHtml = (
				<React.Fragment>
					<button type='button' className={stylesPlain.buttonIcon}
						onClick={this.moveUpItem} disabled={readOnly}
					>
						<img src={iconMoveUp} />
					</button>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '5px'}}
						onClick={this.moveDownItem} disabled={readOnly}
					>
						<img src={iconMoveDown} />
					</button>
				</React.Fragment>
			)
		}
		return moveItemsButtonsHtml;
	}
	createButtonDeleteItemHtml() {
		if( this.props.disableDeleteItems )
			return null;
		let buttonDeleteHtml = null;
		if( this.field.value.length != 0 ) {
			let readOnly = getDefinedValue( this.props.readOnly, false);
			buttonDeleteHtml = (
				<React.Fragment>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.deleteItem} disabled={readOnly}
					>
						<img src={iconDelete} />
					</button>
				</React.Fragment>
			);
		}
		return buttonDeleteHtml;
	}
	createLabelStyle() {
		return {marginRight: '10px'};
	}
	createTitleHtml() {
		let titleHtml = null;
		if( this.props.ignoreTitle )
			return titleHtml;
		let title = this.props.title;
		if( ! title )
			title = this.field.model.title;
		if( title ) {
			let tooltip = this.props.tooltip;
			if( ! tooltip )
				tooltip = this.field.model.description;
			let labelStyle = Object.assign(
				{}, this.createLabelStyle(), 
				getDefinedItem(this.props, ['styles', 'label'], {}));
			titleHtml = (<Label title={title} tooltip={tooltip} style={labelStyle} />);
		} 
		return titleHtml;
	}
	createHeaderHtml() {
		if(this.props.header) {
			return ( <this.props.header table={this} readOnly={this.props.readOnly} /> )
		}
		
		let labelEmptyHtml = null;
		let moveItemsButtonsHtml = null;
		let buttonDeleteHtml = null;
		if( this.props.labelEmptyToHeader && this.field.value.length == 0 ) {
			labelEmptyHtml = (
				<div style={{marginRight: '15px', fontStyle: 'italic', color: 'grey'}}>
					{this.resourceFieldList.labelEmptyTable}
				</div>
			);
		} else {
			moveItemsButtonsHtml = this.createMoveItemsButtonsHtml();
			buttonDeleteHtml = this.createButtonDeleteItemHtml();
		}
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px'};
		divHeaderStyle.width = getDefinedItem( this.props, ['table','width'], '100%');
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{this.createButtonAddHtml()}
					{moveItemsButtonsHtml}
					{buttonDeleteHtml}
				</div>
			</div>
		);
		return headerHtml;
	}
	
}

export default FieldList;
